import { useEffect } from 'react'
import {
  useGetAppContextQuery,
  useGetUserContextQuery,
} from '../app/zoomSdkQueries'
import { App, setApp } from '../app/root'
import {
  useGetSubscriptionsQuery,
  useLoginQuery,
  useGetUserAvatarQuery,
} from '../app/appApiQueries'
import {
  useGetRunningContext,
  useAppDispatch,
  useOnCollaborateChange,
  useOnCollaborateRequest,
  useUnfurledFile,
} from '.'

// includes loading of zoomSdk, app context, & checking connectors
export const useInitialAppLoad = (app: App) => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setApp(app))
  }, [dispatch, app])

  const { runningContext, config } = useGetRunningContext()

  // if we came from unfurl, get the file
  useUnfurledFile(app, config?.launchContext?.query)

  useGetUserContextQuery('getUserContext', {
    skip: !(
      runningContext === 'inMeeting' || runningContext === 'inCollaborate'
    ),
  }) // get the user context but its not blocking
  const { appContext } = useGetAppContextQuery('getAppContext', {
    skip: !runningContext, // wait to get app context until config is ready
    pollingInterval: 1000 * 60, // every minute
    selectFromResult: (result) => ({ appContext: result?.data }),
  })

  // get connector information depending on app
  const { authStatus } = useLoginQuery(app, {
    skip: !(appContext && app),
    pollingInterval: 1000 * 60 * 60, // every hour,
    selectFromResult: (result) => ({
      authStatus: result?.data?.data?.authStatus,
    }),
  })

  // get the user avatar if logged in
  useGetUserAvatarQuery(app, {
    skip: !authStatus,
  })

  useOnCollaborateChange(runningContext)
  useGetSubscriptionsQuery(app, {
    skip: app !== 'Google' || !(authStatus && appContext),
  })
  useOnCollaborateRequest(runningContext)

  // hide the collaborate button
  useEffect(() => {
    if (runningContext && runningContext !== 'inMainClient') {
      // ============================= Start V3 =============================
      // Add code back to enable Native Collaboration for Microsoft OneDrive app
      // const setState = app === 'Google' ? 'hidden' : 'disabled'
      // ============================= End V3 =============================
      const setState = 'hidden'
      zoomSdk.zmSetCollaborateButtonState({ setState }).catch(() => {
        // swallow
      })
    }
  }, [runningContext, app])
}
